// Single version anchor for the currently published legal docs bundle.
// When legal documents are updated and users must re-accept, bump this value.
export const LEGAL_DOCS_VERSION = '2026-04-02';
export const OFFER_SUBSCRIPTION_VERSION = '2026-04-25';

